import React, { useContext, useState } from 'react'
import { GlobalContext } from '../../context/provider'
import invoice_ledgeraction from '../../context/action/customer/invoice_ledgeraction';
import Customer_invoice_ledger_table from './customer_invoice_ledger_table';
import Customer_loan_back_ledger_table from './customer_loan_back_ledger_table';
import loan_backaction from '../../context/action/customer/loan_backaction';

const Customerledger = () => {
    const {initState} = useContext(GlobalContext);

    const [table_type,settable_type]=useState('');
    const [invoice,setinvoice]=useState([]);
    const [loan_back,setloan_back]=useState([]);
    var customer_id = initState?.ledger_customer_id;
    return (
        <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-slate-50">
            <div className="w-full h-16 sm:h-20 lg:h-24 flex justify-center items-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-4 sm:mb-6">
                 تۆمارەکانی - {initState?.ledger_customer_name} 
            </div>
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    invoice_ledgeraction(customer_id).then((res)=>{
                        setinvoice(res);
                        settable_type('invoice');
                    });
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        پسوڵەی فرۆشراو
                    </h5>
                    {/* <div className="border-t-2 border-neutral-100 px-6 py-3">
                    {" "}
                    لە بەرواری , بۆ بەرواری , باڕکۆد
                    </div> */}
                </div>
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    loan_backaction(customer_id).then((res)=>{
                        setloan_back(res);
                        settable_type('loan_back');
                    });   
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        قەرزی گەڕاوە
                    </h5>
                    {/* <div className="border-t-2 border-neutral-100 px-6 py-3">
                    {" "}
                    لە بەرواری , بۆ بەرواری , باڕکۆد
                    </div> */}
                </div>
            </div>
            <div className="mt-6 sm:mt-8 lg:mt-10">
                {table_type=='invoice'? <Customer_invoice_ledger_table invoice={invoice}/>:table_type=='loan_back'?<Customer_loan_back_ledger_table loan_in={loan_back}/> :null}
            </div>
        </div>
    )
}

export default Customerledger